const {CAPTCHA_KEY} = process.env;


const src = `https://www.google.com/recaptcha/api.js?render=${CAPTCHA_KEY}`;


export default src;